import React, { useContext, useEffect, useRef } from 'react';
import { Button, Collapse, Nav, Navbar } from 'reactstrap';
import Scrollbar from 'react-scrollbars-custom';
import Logo from './Logo';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import ToggleButton from './ToggleButton';
import AppContext from '../../context/Context';
import Flex from '../common/Flex';
import { navbarBreakPoint } from '../../config';
import managerRoutes from '../../managerRoutes';
import propertyRoutes, { homeRoutes } from '../../propertyRoutes';
import safetyRoutes from '../../safetyRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { UnselectCondominium } from '../../actions/condominiumActions';
import { useHistory } from 'react-router';
import rootRoutes from '../../rootRoutes';
import providerRoutes from '../../providerRoutes';

const NavbarVertical = () => {

  const dispatch = useDispatch();
  const history = useHistory();
  const { user: { role, hasMultipleProperties } } = useSelector(store => store.auth);
  const { selectedProperty } = useSelector(store => store.property);
  // HO-HU-37: mientras una cuenta con varias propiedades no eligio
  // ninguna, el menu lateral solo muestra "Inicio" (donde esta el
  // selector) -- si no, se podia navegar directo a Mis finanzas/Mis
  // parqueos/etc. antes de elegir, y esas paginas mostrarian datos de
  // "alguna" propiedad (la primera, por el fallback de activeProperty())
  // en vez de pedir explicitamente que se elija una.
  const mustSelectProperty = role === 'property' && hasMultipleProperties && !selectedProperty;
  const routes = {
    property: mustSelectProperty ? [homeRoutes] : propertyRoutes,
    manager: managerRoutes,
    safety: safetyRoutes,
    root: rootRoutes,
    provider: providerRoutes
  }
  const { selectedCondominium } = useSelector(store => store.condominium);
  const navBarRef = useRef(null);
  const { isRTL, showBurgerMenu, isNavbarVerticalCollapsed, setIsNavbarVerticalCollapsed } = useContext(AppContext);
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  //Control Component did mount and unmounted of hover effect
  if (isNavbarVerticalCollapsed) {
    HTMLClassList.add('navbar-vertical-collapsed');
  }

  useEffect(() => {
    return () => { HTMLClassList.remove('navbar-vertical-collapsed-hover'); }
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  //Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  }

  return (
    <Navbar expand={navbarBreakPoint} className="navbar-vertical navbar-glass" light>
      <Flex align="center">
        <ToggleButton
          isNavbarVerticalCollapsed={isNavbarVerticalCollapsed}
          setIsNavbarVerticalCollapsed={setIsNavbarVerticalCollapsed}
        />
        <Logo at="navbar-vertical" bordered width={100} />
      </Flex>

      <Collapse
        navbar
        isOpen={showBurgerMenu}
        className="bg-200"
        innerRef={navBarRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => {
          clearTimeout(time);
          HTMLClassList.remove('navbar-vertical-collapsed-hover');
        }}
      >
        <Scrollbar
          style={{ height: 'calc(100vh - 77px)', display: 'block' }}
          rtl={isRTL}
          trackYProps={{
            renderer(props) {
              const { elementRef, ...restProps } = props;
              return <span {...restProps} ref={elementRef} className="TrackY" />;
            }
          }}
        >
          <Nav navbar vertical>
            <NavbarVerticalMenu routes={routes[role]} />
          </Nav>

          {role === 'manager' && selectedCondominium ?
            <>
              <hr className="border-300 my-3" />
              <Button
                color="primary"
                size="sm"
                block
                className="my-3 btn-purchase"
                onClick={() => {
                  dispatch(UnselectCondominium());
                  history.push("/dashboard/app");
                }}
              >
                Dejar condominio
              </Button>
            </> : role === 'manager' &&
            "Debes seleccionar un condominio"
          }
          {mustSelectProperty && "Debes seleccionar una propiedad"}
        </Scrollbar>
      </Collapse>
    </Navbar>
  )
}

export default React.memo(NavbarVertical);